import { Button, Form, FormInstance, Input, message, Space, Typography } from "antd";
import React, { useEffect, useRef } from "react";
import SkillRateCardTable from "./Steps/RateCards";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Stepper from "./Stepper";
import BasicDetails from "./Steps/BasicDetails";
import LegalTerms from "./Steps/Legal";
import Agreements from "./Steps/Agreements";
import PointOfContact from "./Steps/PointOfcontact";
import { getData } from "../../actions/apiCall";

const VendoRegistrationForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState<boolean>(false);
    const id = new URLSearchParams(window.location.search).get('vendor') || '';

    const basicDetailsRef = useRef<any>();
    const pointOfContactRef = useRef<any>();
    const rateCardRef = useRef<any>();
    const legalTermsRef = useRef<any>();
    const agreementsRef = useRef<any>();

    const refs = [
        basicDetailsRef,
        pointOfContactRef,
        rateCardRef,
        legalTermsRef,
        agreementsRef,
    ];

    const steps = [
        { title: "Basic Details", content: <BasicDetails ref={basicDetailsRef} onLoadingChange={(e) => setLoading(e)} /> },
        { title: "Point of Contact", content: <PointOfContact ref={pointOfContactRef} onLoadingChange={(e) => setLoading(e)} /> },
        { title: "Rate Card", content: <SkillRateCardTable ref={rateCardRef} onLoadingChange={(e) => setLoading(e)} /> },
        { title: "Legal Terms", content: <LegalTerms ref={legalTermsRef} onLoadingChange={(e) => setLoading(e)} /> },
        { title: "NDA", content: <Agreements ref={agreementsRef} onLoadingChange={(e) => setLoading(e)} /> },
    ];

    const handleNext = async (current: number) => {
        const resData = await dispatch(getData(`/v1/vendor/${id}`));
        if (resData?.data?.msaSigned || resData?.data?.ndaSigned) {
            return true
        } else {
            const isValid = await refs[current].current?.submitStep?.();
            return isValid
        }
    };

    const handlePrev = async (current: number) => {
        return true
    };

    const handleSubmit = async () => {
        const resData = await dispatch(getData(`/v1/vendor/${id}`));
        if (resData?.data?.msaSigned && resData?.data?.ndaSigned) {
            return true
        } else {
            message.error('Please complete all steps before submitting.');
            return false
        }
    };

    return (
        <>
            <div className="min-h-screen bg-[#e5e8f3]">
                <div className="bg-white w-full fixed top-0 z-10 shadow-md">
                    <img src={require('./../../assets/logo/logo.png')} alt="Logo" className="w-50 p-4" />
                </div>
                <div className="flex justify-center mt-14">
                    <div className="container mx-auto p-4 w-full max-w-5xl bg-white rounded mt-10 mb-10">
                        <div className="mb-4">
                            <h2 className="text-lg font-semibold">Vendor Registration</h2>
                            <span className="text-sm text-gray-500">Please fill in the details below</span>
                        </div>
                        <div className="p-4">
                            <Stepper
                                steps={steps}
                                onNext={handleNext}
                                onPrev={handlePrev}
                                onSubmit={handleSubmit}
                                loading={loading}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

export default VendoRegistrationForm;